// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.set-password-content[data-v-39b1998d] {
  margin: auto;
}
.set-password-content .password-setup-form[data-v-39b1998d] {
  min-height: 184px;
}
.set-password-content .password-setup-form .password-icon[data-v-39b1998d] {
  cursor: pointer;
  color: var(--soft-text-color);
  margin-top: 2px;
}
.set-password-content .password-setup-form .password-icon.eye[data-v-39b1998d] {
  margin-right: 1px;
}
.set-password-content .password-setup-form .password-icon.hidden[data-v-39b1998d] {
  display: none;
}
.set-password-content .password-setup-form .overridden-password-field[data-v-39b1998d] {
  margin: 0;
  width: 100%;
}
.set-password-content .strength-message[data-v-39b1998d] {
  margin-top: 5px;
  padding: 12px;
}
.set-password-content .hide-me[data-v-39b1998d] {
  visibility: hidden;
}
.set-password-content .password-strength[data-v-39b1998d] {
  font-size: 12px;
  font-weight: 800;
  line-height: 24px;
  color: var(--soft-text-color);
  padding: 0;
}
.set-password-content .password-recommendations[data-v-39b1998d] {
  margin-top: 10px;
  font-size: 12px;
  line-height: 24px;
  color: var(--soft-text-color);
  padding: 0;
}
.set-password-content .password-requirements[data-v-39b1998d] {
  font-size: 12px;
  line-height: 24px;
}
.set-password-content .password-requirements > ul[data-v-39b1998d] {
  list-style: none;
  padding: 0;
  margin: 0;
}
.set-password-content .password-requirements > ul li[data-v-39b1998d] {
  color: var(--bad-color);
}
.set-password-content .password-requirements > ul li.done[data-v-39b1998d] {
  color: var(--good-color);
}
.set-password-content .special-character-tooltip[data-v-39b1998d] {
  font-size: 12px;
  line-height: 18px;
}
.set-password-content .btn-container[data-v-39b1998d] {
  max-width: 300px;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./js/components/password-setup-view/PasswordEntry.component.vue","webpack://./PasswordEntry.component.vue"],"names":[],"mappings":"AACA;EACE,YAAA;ACAF;ADEE;EACE,iBAAA;ACAJ;ADCI;EACE,eAAA;EACA,6BAAA;EACA,eAAA;ACCN;ADCM;EACE,iBAAA;ACCR;ADEM;EACE,aAAA;ACAR;ADII;EACE,SAAA;EACA,WAAA;ACFN;ADME;EACE,eAAA;EACA,aAAA;ACJJ;ADOE;EACE,kBAAA;ACLJ;ADQE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,UAAA;ACNJ;ADSE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,UAAA;ACPJ;ADUE;EACE,eAAA;EACA,iBAAA;ACRJ;ADUI;EACE,gBAAA;EACA,UAAA;EACA,SAAA;ACRN;ADSM;EACE,uBAAA;ACPR;ADUM;EACE,wBAAA;ACRR;ADaE;EACE,eAAA;EACA,iBAAA;ACXJ;ADcE;EACE,gBAAA;EACA,cAAA;ACZJ","sourcesContent":["\n.set-password-content {\n  margin: auto;\n\n  .password-setup-form {\n    min-height: 184px;\n    .password-icon {\n      cursor: pointer;\n      color: var(--soft-text-color);\n      margin-top: 2px;\n\n      &.eye {\n        margin-right: 1px;\n      }\n\n      &.hidden {\n        display: none;\n      }\n    }\n\n    .overridden-password-field {\n      margin: 0;\n      width: 100%;\n    }\n  }\n\n  .strength-message {\n    margin-top: 5px;\n    padding: 12px;\n  }\n\n  .hide-me {\n    visibility: hidden;\n  }\n\n  .password-strength {\n    font-size: 12px;\n    font-weight: 800;\n    line-height: 24px;\n    color: var(--soft-text-color);\n    padding: 0;\n  }\n\n  .password-recommendations {\n    margin-top: 10px;\n    font-size: 12px;\n    line-height: 24px;\n    color: var(--soft-text-color);\n    padding: 0;\n  }\n\n  .password-requirements {\n    font-size: 12px;\n    line-height: 24px;\n\n    > ul {\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      li {\n        color: var(--bad-color);\n      }\n\n      li.done {\n        color: var(--good-color);\n      }\n    }\n  }\n\n  .special-character-tooltip {\n    font-size: 12px;\n    line-height: 18px;\n  }\n\n  .btn-container {\n    max-width: 300px;\n    margin: 0 auto;\n  }\n}\n\n",".set-password-content {\n  margin: auto;\n}\n.set-password-content .password-setup-form {\n  min-height: 184px;\n}\n.set-password-content .password-setup-form .password-icon {\n  cursor: pointer;\n  color: var(--soft-text-color);\n  margin-top: 2px;\n}\n.set-password-content .password-setup-form .password-icon.eye {\n  margin-right: 1px;\n}\n.set-password-content .password-setup-form .password-icon.hidden {\n  display: none;\n}\n.set-password-content .password-setup-form .overridden-password-field {\n  margin: 0;\n  width: 100%;\n}\n.set-password-content .strength-message {\n  margin-top: 5px;\n  padding: 12px;\n}\n.set-password-content .hide-me {\n  visibility: hidden;\n}\n.set-password-content .password-strength {\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 24px;\n  color: var(--soft-text-color);\n  padding: 0;\n}\n.set-password-content .password-recommendations {\n  margin-top: 10px;\n  font-size: 12px;\n  line-height: 24px;\n  color: var(--soft-text-color);\n  padding: 0;\n}\n.set-password-content .password-requirements {\n  font-size: 12px;\n  line-height: 24px;\n}\n.set-password-content .password-requirements > ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.set-password-content .password-requirements > ul li {\n  color: var(--bad-color);\n}\n.set-password-content .password-requirements > ul li.done {\n  color: var(--good-color);\n}\n.set-password-content .special-character-tooltip {\n  font-size: 12px;\n  line-height: 18px;\n}\n.set-password-content .btn-container {\n  max-width: 300px;\n  margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
